import styles from './AgriTourStepper.module.css';

type StepState = 'done' | 'active' | 'pending';

interface AgriTourStepperProps {
  steps: { id: string; title: string }[];
  activeIndex: number;
  embedded?: boolean;
}

export default function AgriTourStepper({
  steps,
  activeIndex,
  embedded = false,
}: AgriTourStepperProps) {
  const progressPct = Math.round(((activeIndex + 1) / steps.length) * 100);

  return (
    <nav
      className={`${styles.stepper} ${embedded ? styles.stepperEmbedded : ''}`}
      aria-label="שלבי הטופס"
    >
      <div className={styles.progressMeta}>
        <span className={styles.progressLabel}>
          שלב {activeIndex + 1} מתוך {steps.length}
        </span>
        <span className={styles.progressPct} aria-hidden>
          {progressPct}%
        </span>
      </div>
      <div
        className={styles.progressTrack}
        role="progressbar"
        aria-valuenow={progressPct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`התקדמות בטופס — ${progressPct} אחוז`}
      >
        <div className={styles.progressFill} style={{ width: `${progressPct}%` }} />
      </div>
      <ol className={styles.list}>
        {steps.map((step, index) => {
          const state: StepState =
            index < activeIndex ? 'done' : index === activeIndex ? 'active' : 'pending';
          const marker = state === 'done' ? '✓' : String(index + 1);

          return (
            <li
              key={step.id}
              className={`${styles.step} ${state === 'active' ? styles.stepActive : ''} ${state === 'done' ? styles.stepDone : ''} ${state === 'pending' ? styles.stepPending : ''}`}
              aria-current={state === 'active' ? 'step' : undefined}
            >
              <span className={styles.number} aria-hidden>{marker}</span>
              <span className={styles.label}>{step.title}</span>
              {index < steps.length - 1 ? <span className={styles.divider} aria-hidden /> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
